import {
    SEARCH_REFERRALS,
    REFRESH_REFERRAL_STATUS,
    LIST_REFERRALS,
    FETCH_REFERRAL_DETAILS,
    FETCH_REFERRAL_CONTENT,
    OPEN_REFERRAL_DETAILS_DIALOG
} from './ReferralListActionTypes';
import {switchMap, map, catchError, withLatestFrom, mergeMap} from 'rxjs/operators';
import {combineEpics, ofType} from 'redux-observable';
import {of} from 'rxjs';
import config from 'react-global-configuration';
import {
    errorHandlingWithLogoutCheck,
    getJsonWithAuth,
    postJsonWithAuth
} from "../../../components/AjaxHelpers";
import {referralListActions} from "./index";

export const referralListEpics = combineEpics(
    (action$, state$) => action$.pipe(
        ofType(SEARCH_REFERRALS),
        withLatestFrom(state$),
        switchMap(([action, state]) => {
            const queryParams = new URLSearchParams({
                personnummer: action.personnummer,
                careUnitId: action.careUnitId,
            });

            return getJsonWithAuth({
                url: `${config.get('apiBaseUrl')}/referrals/v1/search?${queryParams.toString()}`,
                state,
            }).pipe(
                map(payload => referralListActions.searchReferralsSucceeded(payload)),
                catchError(response =>
                    errorHandlingWithLogoutCheck(
                        response,
                        [referralListActions.searchReferralsFailed(response)],
                        "Något gick fel när remisser skulle hämtas."
                    )
                )
            );
        })
    ),

    (action$, state$) => action$.pipe(
        ofType(REFRESH_REFERRAL_STATUS),
        withLatestFrom(state$),
        switchMap(([action, state]) => {
            const encodedReferralId = encodeURIComponent(action.referralId);

            return postJsonWithAuth({
                url: `${config.get('apiBaseUrl')}/referrals/v1/${encodedReferralId}/refresh`,
                state,
                body: {}
            }).pipe(
                map(ajaxResponse => {
                    console.log('Refresh response:', ajaxResponse);
                    // The actual JSON body is in ajaxResponse.response
                    return referralListActions.refreshReferralStatusSucceeded(ajaxResponse.response);
                }),
                catchError(response =>
                    errorHandlingWithLogoutCheck(
                        response,
                        [referralListActions.refreshReferralStatusFailed(response)],
                        "Något gick fel när status skulle uppdateras."
                    )
                )
            );
        })
    ),

    (action$, state$) => action$.pipe(
        ofType(LIST_REFERRALS),
        withLatestFrom(state$),
        switchMap(([action, state]) => {
            const queryParams = new URLSearchParams();
            if (action.careUnitId) {
                queryParams.append('careUnitId', action.careUnitId);
            }
            if (action.opticianId) {
                queryParams.append('opticianId', action.opticianId);
            }
            queryParams.append('page', action.page != null ? action.page : 0);
            queryParams.append('size', 25);

            const queryString = queryParams.toString();
            const url = `${config.get('apiBaseUrl')}/referrals/v1/list?${queryString}`;

            return getJsonWithAuth({
                url,
                state,
            }).pipe(
                map(payload => referralListActions.listReferralsSucceeded(payload)),
                catchError(response =>
                    errorHandlingWithLogoutCheck(
                        response,
                        [referralListActions.listReferralsFailed(response)],
                        "Något gick fel när remisser skulle hämtas."
                    )
                )
            );
        })
    ),

    (action$, state$) => action$.pipe(
        ofType(FETCH_REFERRAL_DETAILS),
        withLatestFrom(state$),
        switchMap(([action, state]) => {
            const encodedReferralId = encodeURIComponent(action.referralId);

            return getJsonWithAuth({
                url: `${config.get('apiBaseUrl')}/referrals/v1/${encodedReferralId}/details`,
                state,
            }).pipe(
                map(payload => referralListActions.fetchReferralDetailsSucceeded(payload)),
                catchError(response =>
                    errorHandlingWithLogoutCheck(
                        response,
                        [referralListActions.fetchReferralDetailsFailed(response)],
                        "Något gick fel när remissdetaljer skulle hämtas."
                    )
                )
            );
        })
    ),

    (action$, state$) => action$.pipe(
        ofType(FETCH_REFERRAL_CONTENT),
        withLatestFrom(state$),
        switchMap(([action, state]) => {
            const encodedReferralId = encodeURIComponent(action.referralId);

            return getJsonWithAuth({
                url: `${config.get('apiBaseUrl')}/referrals/v1/${encodedReferralId}/content`,
                state,
            }).pipe(
                map(payload => referralListActions.fetchReferralContentSucceeded(payload)),
                catchError(response =>
                    errorHandlingWithLogoutCheck(
                        response,
                        [referralListActions.fetchReferralContentFailed(response)],
                        "Något gick fel när remissinnehåll skulle hämtas."
                    )
                )
            );
        })
    ),

    (action$, state$) => action$.pipe(
        ofType(OPEN_REFERRAL_DETAILS_DIALOG),
        mergeMap(action => of(
            referralListActions.fetchReferralContent(action.referralId),
            referralListActions.fetchReferralDetails(action.referralId)
        ))
    ),
);